import { Component } from '@angular/core';
import { DividerModule } from 'primeng/divider';
import { SidebarUserInfoComponent } from '../user-info/feature/user-info.component';

@Component({
    selector: 'app-side-panel',
    imports: [DividerModule, SidebarUserInfoComponent],
    templateUrl: '../ui/side-panel.component.html'
})
export class SidePanelComponent {

}
